import { IEnvironmentType } from "./environmentType";

export const prodEnv: IEnvironmentType = {
    isProduction: true,
    graphqlApi: 'https://api.lnrouter.app/graphql',
    lnrouter_env: 'production',
    domain: 'lnrouter.app',
    pricing: [
        {
            months: 1,
            offPercent: 0,
            monthlyPriceSat: 21000,
            id: 1,
        },
        {
            months: 3,
            offPercent: 0.1,
            monthlyPriceSat: 18900,
            id: 2,
        },
        {
            months: 6,
            offPercent: 0.2,
            monthlyPriceSat: 16800,
            id: 3,
        },
    ]
}
